export default "__VITE_ASSET__CziMAx9___"